import React, { useState } from 'react'
import { UserContextProvider } from '../context/UserContext'
import Layout from '../components/Layout'
import { toast } from 'react-toastify'
import { createNews } from '../services/news.service'
import { useNavigate } from 'react-router-dom'
import BeritaForm from '../sections/BeritaForm'

const CreateBerita = () => {
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()

  const onSubmit = async (e) => {
    try {
      setIsLoading(true)
      e.preventDefault()
      const data = new FormData(e.target)
      await createNews({ form: data })
      toast.success('Berhasil menambahkan berita')
      navigate('/konten/berita')
    } catch (error) {
      toast.error(error?.response?.data?.error?.message ?? 'Error')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <UserContextProvider>
      <Layout
        activeNav="Berita"
        isBackButtonShown={true}
        isPreviewShown={true}
        previewComponent={
          <div>
            <p className="font-semibold text-[28px] my-4">Preview</p>
            <img
              src={
                'https://nos.wjv-1.neo.id/jakmania-bucket/assets/Tutor%20CMS/News/News-x3.png'
              }
              className="object-contain mx-auto w-[210px] h-[480px] mb-4"
              alt='Preview'
            />
            <p className="font-normal text-[16px]">Deskripsi</p>
            <p className="opacity-70 text-[14px] mb-4">
              Perubahan pada berita akan mempengaruhi detail Jakmania Kini,
              berita yang kamu upload nanti akan masuk ke aplikasi the Jakmania.
            </p>
            <p className="font-normal text-[16px]">Ribbon</p>
            <p className="opacity-70 text-[14px] mb-4">
              Tulisan yang akan muncul di depan berita{' '}
            </p>
          </div>
        }
      >
        <BeritaForm onSubmit={onSubmit} isLoading={isLoading} />
      </Layout>
    </UserContextProvider>
  )
}

export default CreateBerita
